







import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Header extends Vue {
  @Prop({ type: String, required: true }) private name!: string;
  @Prop({ type: String, required: false }) private text!: string;
}
